import { NavLink } from 'react-router-dom'
import { internalChannel, internalVacancies, lateralMenuTextTranslate, successionPlanTranslate } from '../../../../i18n/translatedMessages'
import { useIntl } from 'react-intl'

import {
	AssessmentCenterIcon,
	CareerPlanIcon,
	ClimeCultureIcon,
	DocumentsIcon,
	ExitPlanIcon,
	InternalComunicationIcon,
	InternalJobsIcon,
	MyCompanyIcon,
	OmbusdmanIcon,
	OnboardingIcon,
	PeopleAnalitycsIcon,
	PerformanceIcon,
	SalaryIcon,
	SuccessionPlanIcon,
	SupportMyDNAIcon,
	TrainingsIcon,
	NominaIcon,
} from './MenuIcons'

const menuItems = [
	{
		name: lateralMenuTextTranslate.myBusiness,
		icon: <MyCompanyIcon />,
		route: '/app/services/edit-industry',
	},
	{
		name: 'People Analytics',
		icon: '',
		route: '/app/analytics',
		active: true,
		children: [
			{
				name: 'Mis Colaboradores',
				route: '/app/services/list',
			},
			{
				name: 'Registro de Colaborador',
				route: '/app/services/new',
			},
			{
				name: 'Registro Masivo',
				route: '/app/services/multiple-add',
			},
			{
				name: 'Campaña Colaborador',
				route: '/app/services/campaign',
			},
		],
	},
	{
		name: 'Documentos',
		icon: '',
		route: '/app/documents',
	},
	{
		name: 'Nómina',
		icon: '',
		route: '/app/payroll',
	},
	{
		name: 'Onboarding',
		icon: '',
		route: '/app/onboarding',
	},
	{
		name: 'Entrenamiento & Desarrollo',
		icon: '',
		route: '/app/training',
	},
	{
		name: 'Clima & Cultura',
		icon: '',
		route: '/app/culture',
	},
	{
		name: 'Desempeño y Potencial',
		icon: '',
		route: '/app/performance',
	},
	{
		name: 'Salario & Beneficios',
		icon: '',
		route: '/app/benefits',
	},
	{
		name: 'Assessment Center',
		icon: '',
		route: '/app/assessment',
	},
	{
		name: 'Plan de Carrera',
		icon: '',
		route: '/app/career',
	},
	{
		name: 'Plan de Sucesión',
		icon: '',
		route: '/app/succession',
	},
	{
		name: 'Vacantes internas',
		icon: '',
		route: '/app/internal-vacancies',
	},
	{
		name: 'Comunicación interna',
		icon: '',
		route: '/app/internal-communication',
	},
	{
		name: 'Feedbacks',
		icon: '',
		route: '/app/feedbacks',
	},
]

export default function SideMenuResponsive({ handleMenu, option }) {
	return (
		<div className='tw-w-[280px] tw-h-screen tw-overflow-y-auto tw-py-6 tw-px-2  tw-text-sm'>
			{menuItems.map((item, idx) => (
				<div key={idx} className='tw-mb-2'>
					<NavLink
						onClick={handleMenu}
						data-option={option}
						to={item.route}
						className={({ isActive }) =>
							`tw-flex tw-items-center tw-gap-2 tw-py-2 tw-px-4 tw-rounded-lg tw-shadow-sm ${
								isActive || item.active ? 'border border-[#45b9eb] tw-bg-[#444258]' : 'tw-bg-[#444258] hover:tw-bg-purple-500'
							}`
						}
					>
						<span>{item.icon}</span>
						<span className='tw-text-white'>{item.name}</span>
					</NavLink>

					{item.children && (
						<div className='tw-ml-6 tw-mt-1 tw-bg-white tw-rounded-md tw-shadow-sm tw-overflow-hidden tw-text-[#444258] tw-border tw-border-gray-100'>
							{item.children.map((subItem, subIdx) => (
								<NavLink
									key={subIdx}
									onClick={handleMenu}
									data-option={option}
									to={subItem.route}
									className={({ isActive }) =>
										`tw-block tw-py-[10px] tw-px-4 tw-text-sm ${isActive ? 'tw-bg-[#E3F4FD] tw-font-semibold' : 'hover:tw-bg-gray-200'}`
									}
								>
									{subItem.name}
								</NavLink>
							))}
						</div>
					)}
				</div>
			))}
		</div>
	)
}
